var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "rounded-0 h-100", class: _vm.getStyle.bgColor },
    [
      _c(
        "b-media",
        [
          _vm._t("default", null, { slot: "aside" }),
          _vm._v(" "),
          _c("div", { staticClass: "text-right" }, [
            _c("h3", { class: _vm.getStyle.title }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _c("h6", { class: _vm.getStyle.subtitle }, [
              _vm._v(_vm._s(_vm.subtitle))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("i", { class: _vm.getStyle.message }, [
                _vm._v(_vm._s(_vm.message))
              ])
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a63898ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a63898ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Infobox.vue
// module id = Gw9n
// module chunks = 1